import styled from 'styled-components';
import { Pagination } from 'antd';

interface ContainerProps {
    size?: 'small' | 'medium' | 'large';
    isPaginate: boolean;
}

const getSize = (size?: string) => {
    switch (size) {
        case 'small':
            return '15vw';
        case 'medium':
            return '23vw';
        case 'large':
            return '30vw';
        default:
            return '25vw';
    }
};

export const Container = styled.div<ContainerProps>`
    background-color: white;
    width: ${(props) => getSize(props.size)};
    height: 100%;
    > .ant-list {
        height: 100%;
        > .ant-spin-nested-loading {
            height: calc(100vh - ${(props) => props.isPaginate ? "210px" : "120px"}); 
            overflow-y: scroll;
        }

        > .ant-list-footer {
            border-top: 1px solid #f0f0f0;
        }
    }
    > .ant-list-bordered {
        border-radius: 0px;
        border-top: 0px;
    }
}
`;

export const PaginationList = styled(Pagination)`
width: max-content;
margin: auto;
}
`;

export const Header = styled.div`
    height: 35px;
    > button {
        float: right;
    }
}
`;
